import React, { useState, useRef } from "react";
import "./Transportation_of_building_materials.css";
import { Link } from "react-router-dom";
import ContactSection2 from "../Category/ContactSection2";
import Adsense from "../Adsense";
import InArticleAd from "../InArticleAd";

export default function Transporting_heavy_equipment() {
  return (
    <div className="Transportation_of_building_materials-page">

      <div className="Transportation_of_building_materials-hero">
        <div className="Transportation_of_building_materials-overlay">
          <h1>הובלת ציוד כבד</h1>
        </div>
      </div>

      {/* =====================================================
          CONTENT
      ===================================================== */}

      <div className="page3">

        <div className="container">

          {/* =====================================================
              VIDEO - ראשון
          ===================================================== */}

          <div className="building-video-box">

            <div className="building-video-title">
              הובלת ציוד כבד
            </div>

            <div className="building-video-wrapper">

              <video
                className="building-video"
                controls
                controlsList="nodownload"
                disablePictureInPicture
                playsInline
                preload="metadata"
                onContextMenu={(e) => e.preventDefault()}
              >
                <source
                  src="/video/9.mp4"
                  type="video/mp4"
                />

                הדפדפן שלך אינו תומך בניגון וידאו.
              </video>

            </div>

            <p className="building-video-caption">
              צפו בסרטון והכירו את שירותי הובלת הציוד הכבד של נצר הובלות ומנופים
            </p>

          </div>


          {/* =====================================================
              TOP TEXT
          ===================================================== */}

          <h2 className="top-text">
            הובלת ציוד כבד דורשת תכנון נכון, ציוד מתאים וניסיון
            בעבודה עם מטענים בגדלים ובמשקלים שונים. נצר הובלות ומנופים
            מספקת שירותי הובלת ציוד כבד לקבלנים, חברות, מפעלים, עסקים
            ולקוחות פרטיים, בהתאם לסוג המטען, למשקל ולתנאי השטח.
          </h2>


          {/* =====================================================
              IMAGE + TEXT
          ===================================================== */}

          <div className="content-row">

            <div className="image-box">
              <img
                src="/images/14.jpeg"
                alt="הובלת ציוד כבד"
              />
            </div>

            <div className="text-box">

              <p>
                הובלת ציוד כבד דורשת התאמה בין סוג המטען, המשקל,
                המידות ותנאי הגישה במקום האיסוף והפריקה. לפני ביצוע
                ההובלה חשוב לבחון את סוג הציוד, משקלו, מידותיו,
                אופן ההעמסה והפריקה והאפשרות להגיע בבטחה לנקודת היעד.
              </p>

              <p>
                נצר הובלות ומנופים מספקת פתרונות להובלת מגוון רחב של
                ציוד כבד, לרבות מכונות, כלי עבודה, ציוד תעשייתי,
                ציוד לאתרי בנייה, מתקנים, חלקי מכונות ומטענים כבדים
                נוספים, בהתאם לסוג ההובלה ולתנאים בשטח.
              </p>

            </div>

          </div>


          {/* =====================================================
              SECTION 1
          ===================================================== */}

          <h2 className="main-title">
            הובלת ציוד כבד – תכנון נכון לפני תחילת העבודה
          </h2>

          <div className="bottom-text">

            <p>
              כל הובלת ציוד כבד מתחילה בבדיקת פרטי ההובלה. יש להבין
              מהו סוג הציוד, מה המשקל הכולל, מהן מידות המטען ומהי
              נקודת האיסוף והפריקה.
            </p>

            <p>
              בנוסף יש לבחון את תנאי הדרך ואת הגישה לאתר, לרבות
              רחובות צרים, חניות, שערים, אתרי בנייה, מפעלים, כניסות
              מורכבות ומגבלות אחרות שעלולות להשפיע על ביצוע ההובלה.
            </p>


            {/* =====================================================
                SECTION 2
            ===================================================== */}

            <h2 className="main-title">
              הובלת ציוד כבד באמצעות משאית
            </h2>

            <p>
              משאית מתאימה מאפשרת להעביר ציוד כבד מאתר אחד לאחר
              בצורה מסודרת. התאמת המשאית נעשית בהתאם לסוג המטען,
              למשקל, למידות ולתנאי הגישה.
            </p>

            <p>
              במקרים שבהם יש צורך גם בהעמסה או בפריקה באמצעות מנוף,
              ניתן לשלב פתרון הכולל הובלה ומנוף בהתאם לדרישות העבודה
              ולתנאי השטח.
            </p>


            {/* =====================================================
                SECTION 3
            ===================================================== */}

            <h2 className="main-title">
              הובלת ציוד כבד לאתרי בנייה ומפעלים
            </h2>

            <p>
              באתרי בנייה, מפעלים ועסקים יש לעיתים צורך בהובלה של
              ציוד כבד, מכונות ומתקנים ממקום למקום. הובלה מסודרת
              מאפשרת להעביר את הציוד אל היעד בהתאם לתכנון העבודה.
            </p>

            <p>
              נצר הובלות ומנופים מספקת שירותי הובלת ציוד כבד לאתרי
              בנייה, מפעלים, עסקים ולמגוון נקודות ברחבי הארץ, בהתאם
              לצורכי הלקוח ולתנאי השטח.
            </p>


            {/* =====================================================
                SECTION 4
            ===================================================== */}

            <h2 className="main-title">
              הובלת ציוד כבד עם מנוף
            </h2>

            <p>
              במקרים שבהם נקודת הפריקה אינה נגישה ישירות למשאית,
              ניתן להשתמש במנוף לצורך הרמת הציוד והעברתו אל נקודת
              הפריקה המתאימה, בהתאם לאפשרויות העבודה בשטח.
            </p>

            <p>
              שילוב של הובלה ומנוף יכול לסייע במקרים שבהם נדרשת
              הרמה של מכונות, מתקנים, ציוד תעשייתי או מטענים כבדים
              אל אזורים שבהם אין אפשרות לפריקה רגילה.
            </p>


            {/* =====================================================
                SECTION 5
            ===================================================== */}

            <h2 className="main-title">
              הובלת מכונות, מתקנים וציוד תעשייתי
            </h2>

            <p>
              ציוד כבד כולל מגוון רחב של מכונות, מתקנים וציוד
              תעשייתי בגדלים ובמשקלים שונים. לפני ביצוע העבודה יש
              לבדוק את משקל המטען, מידותיו ואופן ההעמסה והפריקה.
            </p>

            <p>
              בהתאם לסוג העבודה ניתן לתכנן את ההובלה כך שתתאים
              למשקל הציוד, למידותיו ולתנאי הגישה באתר.
            </p>


            {/* =====================================================
                SECTION 6
            ===================================================== */}

            <h2 className="main-title">
              למה חשוב לבחור חברה מקצועית להובלת ציוד כבד?
            </h2>

            <p>
              הובלת ציוד כבד דורשת היכרות עם סוגי מטענים שונים,
              תכנון נכון והתאמת אמצעי ההובלה למשימה. בדיקה מוקדמת
              של תנאי השטח יכולה לסייע בתכנון יעיל של ההובלה.
            </p>

            <p>
              נצר הובלות ומנופים מתאימה את פתרון ההובלה לסוג הציוד,
              למשקל המטען, למידותיו, לתנאי הדרך ולדרישות הפרויקט.
            </p>


            {/* =====================================================
                SECTION 7
            ===================================================== */}

            <h2 className="main-title">
              נצר הובלות ומנופים – הובלת ציוד כבד בפריסה ארצית
            </h2>

            <p>
              נצר הובלות ומנופים בע"מ מספקת שירותי הובלת ציוד כבד,
              מכונות, מתקנים וציוד תעשייתי לאתרי בנייה, מפעלים,
              עסקים ולקוחות פרטיים. השירות ניתן בהתאם לסוג המטען
              ולתנאים הקיימים בשטח.
            </p>

            <p>
              צריכים הובלת ציוד כבד? צרו איתנו קשר, ספרו לנו מה
              אתם צריכים להוביל ונבחן עבורכם את פתרון ההובלה
              המתאים.
            </p>

          </div>


          {/* =====================================================
              CONTACT
          ===================================================== */}

          <ContactSection2 />


          {/* =====================================================
              LINKS
          ===================================================== */}

          <div className="links">

            <Link
              to="/Transporting_wood"
              className="link-right"
            >
             הובלת עצים
            </Link>

            <Link
              to="/Container_Transportation"
              className="link-left"
            >
              הובלת מכולות
            </Link>

          </div>

        </div>

      </div>

    </div>
  );
}
